export default __webpack_public_path__ + "static/media/edit.73218e09.svg";